/* eslint-disable react/jsx-no-undef */
import { queryUserList } from '@api/roleManagement';
import { ZeissInput } from '@components/input';
import ZeissRangePicker from '@components/rangePicker';
import ZeissSelect from '@components/select';
import { DIC_FIELD_NAMES, ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { SystemCityItemInterface } from '@store/systemCityStore';
import { Cascader, Col, Form, Row } from 'antd';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useRecoilState } from 'recoil';
import { dataFlagList } from '../tool';
import './index.scss';
import { useSectorMark } from '@hooks/useSectorMarkHook';
import { announcementTabStatusMap } from '../announcement';
import { dealerSectorArr } from '../Announcement/CreateAnnouncement';

interface SearchFormPropsInterface {
  onFieldsChange?: () => void;
  dicList: any;
  systemCity: SystemCityItemInterface[];
  tabKey: string;
}

const overdueBooleanArr = [
  {
    label: '是',
    value: '1'
  },
  {
    label: '否',
    value: '0'
  }
];

const AnnouncementSearchForm = (props: SearchFormPropsInterface, ref: any) => {
  const { dicList, systemCity, tabKey, onFieldsChange } = props;
  const [form] = Form.useForm();
  const { sector, noticeType, productLine, subjectMatterClassTypeAi } = dicList;
  const [userInfos] = useRecoilState(userInfo);
  const sectorMark = useSectorMark();
  const showDealerName =
    userInfos.roleKeys === ROLE_KEYS_MAP.admin ||
    (userInfos.roleKeys === ROLE_KEYS_MAP.sales &&
      userInfos.userTypesId
        ?.split(',')
        .some((sectorId: string) => dealerSectorArr.includes(sectorId)));
  const [, setUserList] = useState<any>([]);
  const getQueryUserList = async () => {
    const res = await queryUserList({
      pageNumber: 1,
      pageSize: 9999
    });
    setUserList(res?.users?.records ?? []);
  };

  useEffect(() => {
    getQueryUserList();
  }, []);

  const handeChange = () => {
    onFieldsChange?.();
  };

  // 校验表单内容并且返回数据
  const submitClick = (): Promise<any> => {
    return form.validateFields();
  };

  useImperativeHandle(ref, () => ({
    submitClick,
    resetFields: form.resetFields
  }));

  return (
    <Form form={form} className="contentListForm" onFieldsChange={handeChange}>
      <Row gutter={[24, 0]}>
        <Col span={6}>
          <Form.Item label="公告类型" name="noticeType">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={noticeType}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label={sectorMark} name="sectorType">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              allowClear
              placeholder="请选择"
              options={sector}
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="省市" name="provinceAndCity">
            <Cascader
              options={systemCity}
              placeholder={`请选择省市`}
              className="pc-cascader-layout"
              multiple
              maxTagCount="responsive"
              changeOnSelect
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="产品分类" name="noticeProductLineKey">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={productLine}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="发布时间" name="publishTime">
            <ZeissRangePicker
              format="YYYY-MM-DD"
              allowClear
              placeholder={['开始', '结束']}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="开标时间" name="openTime">
            <ZeissRangePicker
              format="YYYY-MM-DD"
              allowClear
              placeholder={['开始', '结束']}
            />
          </Form.Item>
        </Col>
        {/* <Col span={6}>
          <Form.Item label="当前处理人" name="currentProcessorUserId">
            <ZeissSelect
              // mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={userList}
              allowClear
              fieldNames={{ label: 'realName', value: 'userId' }}
            />
          </Form.Item>
        </Col> */}
        <Col span={6}>
          <Form.Item label="当前处理人" name="queryCurrentProcessorUserName">
            <ZeissInput placeholder="请输入" allowClear />
          </Form.Item>
        </Col>
        {userInfos.roleKeys === ROLE_KEYS_MAP.admin ? (
          <Col span={6}>
            <Form.Item label="公告范围" name="dataFlag">
              <ZeissSelect
                // mode="multiple"
                maxTagCount="responsive"
                maxTagTextLength={7}
                placeholder="请选择"
                options={dataFlagList}
                allowClear
              />
            </Form.Item>
          </Col>
        ) : null}
        {showDealerName ? (
          <Col span={6}>
            <Form.Item label="经销商" name="dealerName">
              <ZeissInput placeholder="请输入" allowClear />
            </Form.Item>
          </Col>
        ) : null}
        {tabKey !== announcementTabStatusMap.Confirmed &&
        tabKey !== announcementTabStatusMap.Uncorrelated &&
        tabKey !== announcementTabStatusMap.Repetition ? (
          <Col span={6}>
            <Form.Item label="是否逾期" name="overdue">
              <ZeissSelect
                maxTagCount="responsive"
                maxTagTextLength={7}
                placeholder="请选择"
                options={overdueBooleanArr}
                allowClear
              />
            </Form.Item>
          </Col>
        ) : null}
        <Col span={6}>
          <Form.Item label="AI预识别" name="classTypeAiList">
            <ZeissSelect
              mode="multiple"
              maxTagCount="responsive"
              maxTagTextLength={7}
              placeholder="请选择"
              options={subjectMatterClassTypeAi}
              allowClear
              fieldNames={DIC_FIELD_NAMES}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
export default forwardRef(AnnouncementSearchForm);
